// src/pages/About.jsx
import React from 'react';

const About = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '2rem auto', padding: '0 1rem' }}>
      <h1>About isLike</h1>
      <p>
        isLike helps you find spots that feel just like the ones you already love.
        Whether you’re traveling for school, work, or simply exploring new corners
        of your city, isLike makes it easy to discover new places that match your favorites.
      </p>

      <h2>How it Works</h2>
      <ul>
        <li>
          <strong>Pick a place you love:</strong> Type in a location you enjoy and
          want to find more of.
        </li>
        <li>
          <strong>Explore similar spots:</strong> Check out places other users say
          are “like” the one you picked.
        </li>
        <li>
          <strong>Vote or add new places:</strong> Help everyone by confirming which
          locations are alike or suggesting new ones you think belong in the list.
        </li>
        <li>
          <strong>Find you new favorites, wherever you go:</strong> Heading to a different city or just another part of town? We’ll suggest spots that match your saved places. Say if your favorite coffee shop is in LA, you’ll know exactly where to go to find a place like it in New York, Austin, or anywhere else you wander. 
        </li>
      </ul>

      <h2>Contact Us</h2>
      <p>
        Have questions, ideas, or just want to say hello?
        Email us at <a href="mailto:hello@islike.com">hello@islike.com</a>.
      </p>
    </div>
  );
};

export default About;
